import React from "react";
import Modal from "../../../../../../_components/Modal";
import Button from "../../../../../../_components/Button";
import Text from "../../../../../../_components/Text";
import Toast from "../../../../../../_components/Toast";
import LoadingInput from "../../../../../../_components/LoadingInput";
import TableData from "../../../../../../_components/TableData";
import { createCCE, getCCeHistory } from "../../../../../../api/nfe";
import { donwloadBase64, showSnackBar } from "../../../../../../utils";
import { Modal as BModal } from "react-bootstrap";
import styled from "styled-components";
import BuyAdditionalNotes from "../../../../../AppViews/Plans/BuyAdditionalNotes";

// --- Estilos para o Modal de Erro de Plano ---
const PlanErrorContainer = styled.div`
  background-color: #d12c2c;
  color: #fff;
  padding: 30px;
  border-radius: 4px;
  position: relative;
`;

const PlanErrorHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  h3 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 700;
    color: #fff !important;
  }

  .icon-circle {
    width: 40px;
    height: 40px;
    border: 2px solid #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    margin-right: 15px;
  }
`;

const PlanErrorClose = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
  opacity: 0.8;
  &:hover {
    opacity: 1;
  }
`;

const PlanErrorSubtitle = styled.p`
  font-size: 1.1rem;
  margin-bottom: 25px;
  strong {
    font-weight: 700;
  }
`;

const PlanErrorList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  border-top: 1px dashed rgba(255, 255, 255, 0.4);
  border-bottom: 1px dashed rgba(255, 255, 255, 0.4);
  padding: 20px 0;

  li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 15px;
    font-size: 1rem;
    line-height: 1.4;

    &:last-child {
      margin-bottom: 0;
    }

    i {
      font-size: 1.3rem;
      margin-right: 15px;
      margin-top: 2px;
      min-width: 25px;
      text-align: center;
    }

    a, button.link-btn {
      color: #fff;
      text-decoration: underline;
      font-weight: 600;
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      font-size: 1rem;
    }
  }
`;

export default (props) => {
  const [loading, setLoading] = React.useState(false);
  const [toast, setToast] = React.useState({});
  const [show, setShow] = React.useState(false);
  const [showPlanError, setShowPlanError] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [x_just, setXJust] = React.useState("");

  function onCreate() {
    setToast({})
    setLoading(true);
    createCCE(props.nfe.id, { x_just })
      .then((resp) => {
        const { key, data } = resp;
        setToast({ message: "Carta de Correção emitida!", show: true })
        donwloadBase64(key, "pdf", "application/pdf", data);
        loadData();
        onHide()
      })
      .catch((resp) => {
        if (resp.data) {
          if (resp.data.plan_error) {
            setShowPlanError(true);
          }
          return;
        }
        if (resp.plan_permission_error) {
          setToast({ message: "Não foi possível emitir a CC-e: Seu plano exige uma nota adicional para essa operação", show: true, type: "error" })
          return
        }
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1500);
      });
  }
  function onShow() {
    setShow(true);
    loadData();
  }
  function onDownload(item, type) {
    donwloadBase64(item.key, type, `application/${type}`, item[`${type}64`]);
  }
  function loadData() {
    setLoading(true);
    getCCeHistory(props.nfe.id)
      .then((data) => {
        data = data.map((item) => {
          return {
            ...item,
            downloads: (
              <div>
                <Button
                  disabled={!item.pdf64}
                  as="text"
                  onClick={() => onDownload(item, "pdf")}
                >
                  <i className="fas fa-file-pdf text-danger mr-4" />
                </Button>
                <Button as="text" onClick={() => onDownload(item, "xml")}>
                  <i className="fas fa-file-code text-info" />
                </Button>
              </div>
            ),
          };
        });
        setData(data);
      })
      .catch((resp) => {
        if (resp.error) {
          showSnackBar(resp.error, "danger", 10000);
          return;
        }
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          try {
            document.querySelector('[name="cce-x-just"]').focus();
          } catch (error) { }
        }, 400);
      });
  }
  function onHide() {
    if (loading) {
      return;
    }
    setShow(false);
    setXJust("");
    setData([]);
  }

  return (
    <React.Fragment>
      <Button
        onClick={onShow}
        as="text"
        className="text-info mx-1"
        disabled={props.nfe.status != 1}
      >
        <i
          className="fas fa-file-signature"
          title="CC-e (Carta de correção eletrônica)"
        />
        <span>CC-e (Carta de correção eletrônica)</span>
      </Button>
      <Modal title="Carta de correção (CC-e) " show={show} onHide={onHide}>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <Text>Destinatário</Text>
              <Text>{props.nfe.recipient_name}</Text>
            </div>
            <div className="col-md-4">
              <Text>Número</Text>
              <Text>{props.nfe.number}</Text>
            </div>
            <div className="col-md-4">
              <Text>Série</Text>
              <Text>{props.nfe.series}</Text>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 my-3">
              <Text>Conteúdo da correção </Text>
              <LoadingInput
                value={x_just}
                name="cce-x-just"
                loading={loading}
                onChange={(e) => setXJust(e.target.value)}
                as="textarea"
                onKeyDown={(e) => {
                  if (e.key === ' ') {
                    setXJust(`${x_just} `)
                  }
                }}
              />
              <span
                className={
                  x_just.length < 15 ? "text-danger d-block" : "d-none"
                }
              >
                O conteúdo da correção precisa ter no mínimo 15 caracteres.
              </span>
            </div>
            <div className="col-md-12 my-3">
              <Button
                onClick={onCreate}
                disabled={loading || x_just.length < 15}
                as="text"
              >
                Enviar correção
              </Button>
            </div>
          </div>
          <div className="row my-3">
            <div className="col-md-12">
              <TableData
                data={data}
                tHead={["Descrição", "Seq.", "Arquivos"]}
                tBodyKeys={["description", "sequence", "downloads"]}
              />
            </div>
          </div>
        </div>
      </Modal>
      <Toast {...toast} />

      {/* Modal de Erro de Plano Customizado */}
      <BModal
        show={showPlanError}
        onHide={() => setShowPlanError(false)}
        dialogClassName="plan-error-modal"
        contentClassName="bg-transparent border-0"
        style={{ marginTop: '5vh' }}
      >
        <PlanErrorContainer>
          <PlanErrorClose onClick={() => setShowPlanError(false)}>
            &times;
          </PlanErrorClose>

          <PlanErrorHeader>
            <div className="icon-circle">
              <i className="fas fa-exclamation" />
            </div>
            <h3>Não foi possível emitir a CC-e.</h3>
          </PlanErrorHeader>

          <PlanErrorSubtitle>
            Você está com <strong>0 nota disponível</strong> ou seu{" "}
            <strong>plano está vencido!</strong>
          </PlanErrorSubtitle>

          <PlanErrorList>
            <li>
              <i className="fas fa-file-invoice-dollar" />
              <span>
                Para emitir a CC-e, adquira <strong>1 nota avulsa</strong> ou
                regularize sua assinatura.
              </span>
            </li>
            <li>
              <i className="fas fa-link" />
              <span>
                Clique aqui para <button className="link-btn" onClick={(e) => {
                  e.preventDefault();
                  const buyBtn = document.getElementById("a3b5f732-871e-5d64-b430-a89c12d5a1f8");
                  if (buyBtn) {
                    setShowPlanError(false);
                    onHide(); // Fecha o modal principal de CCe
                    buyBtn.click();
                  } else {
                    window.location.href = "/plan/branch-invoices";
                  }
                }}>comprar uma nota avulsa</button> ou clique aqui para <button className="link-btn" onClick={(e) => {
                  e.preventDefault();
                  window.location.href = "/plan/branch-invoices";
                }}>visualizar a fatura pendente</button>.
              </span>
            </li>
            <li>
              <i className="fas fa-headset" />
              <span>
                Precisa de ajuda? <button className="link-btn" onClick={(e) => {
                  e.preventDefault();
                  window.open("https://api.whatsapp.com/send?phone=559191629686", "_blank", "noopener,noreferrer");
                }}>Fale com o suporte.</button>
              </span>
            </li>
          </PlanErrorList>
        </PlanErrorContainer>
      </BModal>

      {/* Renderiza o BuyAdditionalNotes de forma invisível mas forçada, para que o botão sempre exista no DOM */}
      <div style={{ display: 'none' }}>
        <BuyAdditionalNotes forceVisible />
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/Actions/CCe/index.jsx